import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class TextSize extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    onChange: PropTypes.func
  }

  tsChange(val){  
    this.props.onChange(val)
  }

  render() {
    console.log("Llega hasta TS: " + this.props.field)
      
    return (
      <div className={styles.container}>
        <select
          value={this.props.value || ''}
          onChange={ event => this.tsChange(event.target.value) }>
          <option value="small">small</option>   
          <option  value="medium">medium</option>   
          <option  value="large">large</option>   
        </select>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Menu/TextSize/index.js